import 'whatwg-fetch';
import { api as oldApi } from 'config';
import { api, apiKey } from 'config/new';
import LoginService from 'services/Login';
import StorageService from 'services/StorageService'
import PubSub from 'services/PubSub';
import UserInfoService from 'services/AccountInfo'

const _apiKey = apiKey['fidelity'];
const fidelityV1 = api['fidelity'];


const register = (card) => {
    if (!card) return false
    const token = LoginService.getUserToken();

    const headers = {
        'apiKey': _apiKey,
        'token': token,
        'Content-Type': 'application/json'
    }

    return fetch(fidelityV1 + '/prime/register', {
        method: 'POST',
        headers,
        body: JSON.stringify(card)
    })
        .then(result => result.json())
}

const cancelSuscription = () => {
    const token = LoginService.getUserToken();

    const headers = {
        'apiKey': _apiKey,
        'token': token,
        'Content-Type': 'application/json'
    }

    return fetch(fidelityV1 + `/prime/suscription`, {
        method: 'PUT',
        headers
    }).then(data => data.json()).then((response) => {
        PubSub.dispatch('update_page_subscription');
        return response
    });

}
const toggleSuscription = (value) => {
    const token = LoginService.getUserToken();

    const headers = {
        'apiKey': _apiKey,
        'token': token,
        'Content-Type': 'application/json'
    }

    return fetch(fidelityV1 + `/prime/suscription`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({active: value})
    }).then(data => data.json());

}
const updatePayMethod = (params) => {
    const {lastDigits, token:_token, brand} = params;
    const token = LoginService.getUserToken();
    const body = {
        cardBin: lastDigits,
        cardToken: _token,
        cardBrand: brand
    }

    const headers = {
        'apiKey': _apiKey,
        'token': token,
        'Content-Type': 'application/json'
    }
    return fetch(fidelityV1 + `/prime/updatePayMethod`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(body)
    }).then(data => data.json()).then((response) => {
        PubSub.dispatch('update_page_subscription');
        return response
    });
}
const getSuscription = () => {
    const token = LoginService.getUserToken();

    const headers = {
        'apiKey': _apiKey,
        'token': token,
        'Content-Type': 'application/json'
    }

    return fetch(fidelityV1 + `/prime/status`, {
        method: 'GET',
        headers
    }).then(data => data.json());
}

const getBenefics = () => {
    const token = LoginService.getUserToken();

    const headers = {
        'apiKey': _apiKey,
        'token': token,
        'Content-Type': 'application/json'
    }

    return fetch(fidelityV1 + `/prime/benefit`, {
        method: 'GET',
        headers
    }).then(data => data.json());
}

const primeDate = () => {
    const token = LoginService.getUserToken();

    const headers = {
        'x-api-key': oldApi.apiKey,
        'token': token,
        'Content-Type': 'application/json',
    }

    return fetch(oldApi.user + `/prime/date`, {
        method: 'POST',
        headers
    }).then(data => data.json());
}

const isPrimeCard = (card) => {
    if (!card) return false;

    const userData = StorageService.getSecureItem('userData');

    if(userData.CencoPrime_CAT || userData.CencoPrime_2020){
        return PrimeService.getSuscription().then(cardPrime => {
            let deleteCard = false;
            let primeStatus = cardPrime?.data?.data;
            if (primeStatus?.card_token === card?.token) {
                deleteCard = true
            } else {
                deleteCard = false
            }
            return deleteCard;
        })
    }else{
        return Promise.resolve(false)
    }
}

const countOrderUser = (qty) =>{

    let data = StorageService.getSecureItem('userData');

    if(data){
        if(qty >= 3){
            data.countOrder = 0;
            return UserInfoService.updateUser(data).then(() => {
                StorageService.setSecureItem('userData', data)
                return qty
            })
        }else{
            let countOrder = (qty + 1);
            data.countOrder = countOrder;
            return UserInfoService.updateUser(data).then(() => {
                StorageService.setSecureItem('userData', data)
                return qty
            })
        }
    }

}

const PrimeService = {
    getSuscription,
    primeDate,
    cancelSuscription,
    isPrimeCard,
    getBenefics,
    toggleSuscription,
    register,
    updatePayMethod,
    countOrderUser
}

export default PrimeService;
